import { useState, useEffect, useCallback } from 'react';

interface BroadcastConfig {
  onMessage?: (event: MessageEvent) => void;
  channelName?: string;
}

const useBroadcast = (config: BroadcastConfig = {}) => {
  const { onMessage, channelName = 'default_channel' } = config;
  const [channelInstance, setChannelInstance] = useState<BroadcastChannel | null>(null);

  const handleMessage = useCallback(
    (event: MessageEvent) => {
      if (onMessage) {
        onMessage(event);
      }
    },
    [onMessage],
  );

  useEffect(() => {
    const channel = new BroadcastChannel(channelName);
    channel.addEventListener('message', handleMessage);

    setChannelInstance(channel);

    return () => {
      channel.removeEventListener('message', handleMessage);
      channel.close();
    };
  }, [channelName, handleMessage]);

  return { channelInstance };
};

export default useBroadcast;
